import React, { useEffect, useState } from "react";
// import { saveAs } from "file-saver";
import { Button, Col, Row } from "react-bootstrap";
import { AiOutlineCheck } from "react-icons/ai";
import { BiMinus } from "react-icons/bi";
import { FaFileDownload } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import IE from "../../../components/Formatters/IE";
import Id from "../../../components/Formatters/Id";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import Label from "../../../components/UI/Label/Label";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import { formatarData } from "../../../components/Formatters/DateTime";
import HtmlToString from "../../../components/Formatters/HtmlToString";
import Base64ToBlob from "../../../components/Formatters/Base64ToBlob";

function htmlToText(html) {
  // Cria um elemento temporário
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // Retorna apenas o texto
  return tempDiv.textContent || tempDiv.innerText || "";
}

const DetalheProcedimento = ({ history, spf }) => {
  const [dados, setDados] = useState({});
  const [anexos, setAnexos] = useState([]);
  const [procedimentos, setProcedimentos] = useState([]);
  const [semDados, setSemDados] = useState(false);
  const [numeroSpf] = useState(spf);

  const { goBack } = history;

  const { request, data, errors, isLoading } = useApiClient();
  const {
    request: requestProcedimento,
    data: dataProcedimento,
    errors: errorsProcedimento,
    isLoading: isloadingProcedimento,
  } = useApiClient();
  const { request: requestAnexo, data: dataAnexo, errors: errorsAnexo, isLoading: isloadingAnexo } = useApiClient();
  const { request: requestDownload, data: dataDownload } = useApiClient();

  useEffect(() => {
    request(apiRoutes.fiscalizacao.procedimentoFiscal.consultaProcedimentoFiscal, { NumSpf: numeroSpf });
  }, [numeroSpf, request]);

  useEffect(() => {
    if ((!data && !errors) || isLoading) return;

    if (data) {
      setDados(data?.result[0]);
      setSemDados(false);

      data.result[0].dataInclusao = formatarData(data.result[0].dataInclusao);
      data.result[0].dataAlteracao = formatarData(data.result[0].dataAlteracao);
      data.result[0].dtFiscalizacaoInicio = formatarData(data.result[0].dtFiscalizacaoInicio);
      data.result[0].dtFiscalizacaoFim = formatarData(data.result[0].dtFiscalizacaoFim);

      const paramsProcedimento = { sqTipoAcaoFiscal: data.result[0].sqTipoAcaoFiscal };
      requestProcedimento(apiRoutes.fiscalizacao.procedimentoFiscal.consultaProcedimentosPorAcao, paramsProcedimento);

      const paramsAnexo = { sqAberturaProcesso: data.result[0].sqAberturaProcesso };
      requestAnexo(apiRoutes.fiscalizacao.procedimentoFiscal.consultaAnexoSpf, paramsAnexo);

      if (data.result[0].sqCobranca !== 0) {
        const paramsCobranca = { sqCobranca: data.result[0].sqCobranca };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadCobranca, paramsCobranca);
      }

      if (data.result[0].sqDenuncia !== 0) {
        const paramsDenuncia = { sqDenuncia: data.result[0].sqDenuncia };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadDenuncia, paramsDenuncia);
      }

      if (data.result[0].sqParteServico !== 0) {
        const paramsParte = { sqParteServico: data.result[0].sqParteServico };
        requestDownload(apiRoutes.fiscalizacao.procedimentoFiscal.downloadParteServico, paramsParte);
      }
    }
    if (!data) {
      setSemDados(true);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, isLoading, requestAnexo, requestDownload, requestProcedimento]);

  useEffect(() => {
    if ((!dataAnexo && !errorsAnexo) || isloadingAnexo) return;

    if (dataAnexo && dataAnexo.result.length) {
      setAnexos(dataAnexo.result);
    }

    if (errorsAnexo) {
      toast.error(errorsAnexo.message);
    }
  }, [dataAnexo, errorsAnexo, isloadingAnexo]);

  useEffect(() => {
    if ((!dataProcedimento && !errorsProcedimento) || isloadingProcedimento) return;

    if (dataProcedimento && dataProcedimento.result.length) {
      if (dados.procedimentos) {
        dados.procedimentos.forEach((item) => {
          if (dataProcedimento.result.filter((x) => x.codigo === parseInt(item, 10))) {
            setProcedimentos((curr) => [
              ...curr,
              dataProcedimento.result.filter((x) => x.codigo === parseInt(item, 10))[0],
            ]);
          }
        });
      }
    }

    if (errorsProcedimento) {
      toast.error(errorsProcedimento.message);
    }
  }, [dados, dataProcedimento, errorsProcedimento, isloadingProcedimento]);

  function StatusAbertura() {
    switch (dados.stAberturaProcesso) {
      case "A":
        return "Aberta";
      case "H":
        return "Homologada";
      case "C":
        return "Cancelada";
      case "R":
        return "Revisão";
      default:
        return "-";
    }
  }

  function retornarOrigem() {
    if (dados?.sqCobranca !== 0) {
      return (
        <>
          <Label>COBRANÇA N° </Label>
          <Link target="_blank" to={{ pathname: `/app/spf/pendencias/detalhe?itemKey=${dados.sqCobranca}&origem=C` }}>
            {dados?.sqCobranca}
          </Link>
          <FileDownloader
            binario={dataDownload}
            tooltip={`Visualizar Cobrança ${dados?.sqCobranca}`}
            nomeArquivo={`cobranca-${dados?.sqCobranca}.html`}
            className="ml-2"
          />
        </>
      );
    }

    if (dados.sqDenuncia !== 0) {
      return (
        <>
          <Label>DENÚNCIA N° </Label>
          <Link target="_blank" to={{ pathname: `/app/spf/pendencias/detalhe?itemKey=${dados.sqDenuncia}&origem=D` }}>
            {dados.sqDenuncia}
          </Link>
          <FileDownloader
            binario={dataDownload}
            tooltip={`Visualizar Denúncia ${dados.sqDenuncia}`}
            nomeArquivo={`denuncia-${dados.sqDenuncia}.pdf`}
            className="ml-2"
          />
        </>
      );
    }

    if (dados.sqParteServico !== 0) {
      return (
        <>
          <Label className="mb-0">PARTE DE SERVIÇO N° </Label>
          <br />
          <Link
            target="_blank"
            to={{ pathname: `/app/spf/pendencias/detalhe/?itemKey=${dados.sqParteServico}&origem=P` }}
          >
            {dados.sqParteServico}
          </Link>
          <FileDownloader
            binario={dataDownload}
            tooltip={`Visualizar Parte de Serviço ${dados.sqParteServico}`}
            nomeArquivo={`parte-servico-${dados.sqParteServico}.pdf`}
            className="ml-2"
          />
        </>
      );
    }

    if (dados.cdNumSei !== null) {
      return <Label>PROCESSO SEI N° {dados.cdNumSei}</Label>;
    }

    if (dados.cdNumSei === null && dados.sqParteServico === 0 && dados.sqDenuncia === 0 && dados.sqCobranca === 0) {
      return <Label>INDIVIDUAL/LOTE</Label>;
    }

    return "-";
  }

  function AnexosDownload(arquivo) {
    const file = new Blob([Base64ToBlob(arquivo.arquivo)], { type: arquivo.tipoArquivo });
    const url = URL.createObjectURL(file);
    window.open(url, "", "width=800,height=800");
    // saveAs(file, arquivo.nomeArquivo);
  }

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          {/* Conteúdo personalizado (card) */}
          {!semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <Col sm="12" className="d-flex">
                    <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                      Detalhes do Procedimento Fiscal Nº:&nbsp;<Label className="m-0">{dados?.codigo}</Label>
                    </h6>
                    {dados?.imArquivo !== null && (
                      <FileDownloader
                        binario={dados?.imArquivo}
                        tooltip={`Visualizar ${dados?.nmArquivo}`}
                        nomeArquivo={dados?.nmArquivo}
                        className="ml-2"
                      />
                    )}
                    {dados?.documento !== null && (
                      <FileDownloader
                        binario={dados?.documento}
                        tooltip={`Visualizar SPF ${dados?.codigo}`}
                        className="ml-2"
                      />
                    )}
                  </Col>
                  <Col sm="1" className="text-right" />
                </Row>
              </div>
              <div className="card-body">
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="2">
                    Insc. Estadual
                    <br />
                    <b>
                      <IE value={dados?.nuInscEstadual} empty="-" />
                    </b>
                  </Col>
                  <Col sm="3">
                    CNPJ/CPF
                    <br />
                    <b>
                      <Id value={dados?.nuCnpj || dados?.nuCnpf} />
                    </b>
                  </Col>
                  <Col sm="7">
                    Contribuinte
                    <br />
                    <b>{dados?.nomeFormal}</b>
                  </Col>
                </Row>
                <Row className="py-2">
                  <Col sm="2">
                    Origem
                    <br />
                    <b>{retornarOrigem()}</b>
                  </Col>
                  <Col sm="3">
                    Tipo de Ação Fiscal
                    <br />
                    <b>{dados?.dsTipoAcaoFiscal}</b>
                  </Col>
                  <Col sm="4">
                    Ciclo
                    <br />
                    <b>{dados?.txCodigoOperacional}</b>
                  </Col>
                  <Col sm="3">
                    Período de Fiscalização
                    <br />
                    <b>{`${dados?.dtFiscalizacaoInicio} - ${dados?.dtFiscalizacaoFim}`}</b>
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="4">
                    Homologador
                    <br />
                    <b>{dados?.nomeHomologador}</b>
                  </Col>
                  <Col sm="4">
                    Setor de Destino
                    <br />
                    <b>{dados?.sgOrgao}</b>
                  </Col>
                  <Col sm="4">
                    Nº OS
                    <br />
                    <b>{dados?.sqOrdemServico === 0 ? <BiMinus /> : dados?.sqOrdemServico}</b>
                  </Col>
                </Row>
                <Row className="py-2">
                  <Col sm="4">
                    Data da Inclusão
                    <br />
                    <b>{dados?.dataInclusao}</b>
                  </Col>
                  <Col sm="4">
                    Data da Alteração
                    <br />
                    <b>{dados?.dataAlteracao === "01/01/0001" ? <BiMinus /> : dados?.dataAlteracao}</b>
                  </Col>
                  <Col sm="4">
                    Status
                    <br />
                    <b>{StatusAbertura()}</b>
                  </Col>
                </Row>
                {dados.stAberturaProcesso === "C" && (
                  <Row className="bg-gray-100 border-bottom-gray py-2">
                    <Col sm="4">
                      Texto Cancelamento <br />
                      {dados?.textoCancelamento}
                    </Col>
                  </Row>
                )}
                {dados.stAberturaProcesso === "R" && (
                  <Row className="bg-gray-100 border-bottom-gray py-2">
                    <Col sm="4">
                      Texto Revisão <br />
                      <b>{dados?.textoRevisao}</b>
                    </Col>
                  </Row>
                )}
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="12">
                    Texto
                    <br />
                    <b>
                      <div dangerouslySetInnerHTML={{ __html: dados?.textoProcedimento ?? "-" }} />
                    </b>
                  </Col>
                </Row>
                <Row className="py-2">
                  <Col sm="12">
                    <h6 className="mt-3">Procedimentos</h6>
                    {procedimentos?.length === 0 && <BiMinus />}
                    <ul className="list-group">
                      {procedimentos?.map((item) => (
                        <li className="list-group-item" key={item.nome}>
                          <AiOutlineCheck className="text-success" />
                          {item.nome}
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
                <Row className="bg-gray-100 border-bottom-gray py-2">
                  <Col sm="12">
                    <h6 className="mt-3">Anexos</h6>
                    {anexos.length === 0 && <BiMinus />}
                    <ul className="list-group">
                      {anexos.map((item) => (
                        <li className="list-group-item" key={item.nomeArquivo}>
                          <button
                            type="button"
                            className="btn btn-link"
                            onClick={(e) => {
                              e.preventDefault();
                              AnexosDownload(item);
                            }}
                            alt=""
                          >
                            <FaFileDownload style={{ marginRight: "7px" }} />
                          </button>
                          {item.nomeArquivo}
                        </li>
                      ))}
                    </ul>
                  </Col>
                </Row>
                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    {spf == null ? (
                      <Button
                        variant="danger"
                        onClick={() => {
                          goBack();
                        }}
                      >
                        Voltar
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              </div>
            </div>
          )}

          {semDados && (
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <Row>
                  <h6 className="m-0 font-weight-bold text-primary d-flex align-items-center">
                    Nenhum Procedimento Fiscal Encontrado.
                  </h6>
                </Row>
                <Row style={{ marginTop: "30px" }} className="py-2">
                  <Col sm="2">
                    {spf == null ? (
                      <Button
                        variant="danger"
                        onClick={() => {
                          goBack();
                        }}
                      >
                        Voltar
                      </Button>
                    ) : null}
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* fim da row */}
    </>
  );
};

export default DetalheProcedimento;
